import React from 'react';
import { AppSkeleton as Skeleton } from '@koopajs/react';
import { Logo } from '../Logo';

export const AppSkeleton: React.FC = () => {
  return (
    <Skeleton showSearchBar componentLogo={<Logo />} searchBarPlaceholder="Search messages, voicemails..." />
  );
};
